import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ParentView from "../../Views/PrarentView/ParentView";
import { getPrasadTempleList } from "../../store/actions/prasadAction";
import PrasadView from "../../Views/Prasad/PrasadView";
import { pageReady } from "../../store/slices/pageViewSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";

function PrasadScreen() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { prasadTempleList, isLoading } = useSelector(
    (state: any) => state.prasad,
  );
  const listingViewedRef = useRef<boolean>(false);
  useEffect(() => {
    dispatch(getPrasadTempleList());
  }, []);

  useEffect(() => {
    const trackPageViewEvent = (prasadTempleList: any) => {
      if (!prasadTempleList) return;
      if (listingViewedRef.current) return;
      listingViewedRef.current = true;
      dispatch(
        pageReady({
          User_ID:
            JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
              ?.id ?? "Guest User",
          Page_Type: "Prasad Temple Listing",
          Listing_Type: "Prasad Listing",
          Total_Items_Shown: prasadTempleList?.length ?? 0,
          Device_Type: getDeviceTypeFromUserAgent(),
        }),
      );
    };

    trackPageViewEvent(prasadTempleList);
  }, [prasadTempleList]);

  const selectChadhavaTemple = (templeDetails: any) => {
    navigate(`/prasadDetails/${templeDetails.nameKey}`);
  };
  return (
    <ParentView>
      <PrasadView
        templeList={prasadTempleList}
        selectTemple={selectChadhavaTemple}
        isLoading={isLoading}
      />
    </ParentView>
  );
}

export default PrasadScreen;
